<template>
    <div :key="refresh" class="custom_input">
        <div v-if="['complex_text'].indexOf(value.type) !== -1">
            <text-editor v-model="localData" />
        </div>
        <div v-else-if="['complex_video'].indexOf(value.type) !== -1">
            <video-editor v-model="localData" />
        </div>
        <div v-else-if="['complex_sound'].indexOf(value.type) !== -1">
            <sound-editor v-model="localData" @validate="$emit('validate', $event)"
                          @loading="$emit('loading', $event)" />
        </div>
        <div v-else-if="['complex_image'].indexOf(value.type) !== -1">
            <image-editor v-model="localData" @validate="$emit('validate', $event)"
                          @loading="$emit('loading', $event)" />
        </div>
        <div class="custom_text_delete_item" @click="storyTryDeleteComponent(index)">
            Supprimer ce composant
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import TextEditor from './EditorText';
    import SoundEditor from './EditorSound';
    import ImageEditor from './EditorImage';
    import VideoEditor from './EditorVideo';

    export default {
        name: 'DynamicInput',
        components: {
            TextEditor,
            SoundEditor,
            ImageEditor,
            VideoEditor
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            index: {
                type: Number,
                default: -1
            },
            refresh: {
                type: Number,
                default: 0
            }
        },
        computed: {
            localData: {
                get () {
                    if (this.value.type === 'complex_text') {
                        return [...this.value.data];
                    } else {
                        return { ...this.value.data };
                    }
                },
                set (data) {
                    if (this.value.type === 'complex_text') {
                        this.updateComponent(this.index, [...data]);
                    } else {
                        this.updateComponent(this.index, { ...data });
                    }
                }
            }
        },
        methods: {
            ...mapActions('actions/story', ['storyUpdateComponent']),
            ...mapActions('actions/story', ['storyTryDeleteComponent']),
            updateComponent: function (index, data) {
                let value = { ...this.value };
                value.data = data;
                this.storyUpdateComponent({ index: index, data: value }).catch((err) => {
                    this.$toasted.error(err);
                });
            }
        }

    };
</script>

<style lang="scss" scoped>

    .custom_text_delete_item {
        font-size: 12px;
        color: red;
        text-align: center;
        font-style: italic;
        padding-bottom: 5px;
        cursor: pointer;
        margin: 10px 0 0;
    }

    .btn-valid:hover {
        color: white !important;
        background-color: #169CEB !important;
    }

    .custom_reset_btn {
        color: #393E46 !important;
        background-color: white !important;
        border: 1px #393E46 solid;
        margin-right: 10px;
    }

    .custom_check_btn {
        color: white !important;
        background-color: #169CEB !important;
        border: 1px #169CEB solid;
        margin-right: 10px;
    }
</style>
